module.exports = __webpack_public_path__ + "img/b79a9d2222d7b9987e2b8e6dcedf75b3.png";